// extracted by mini-css-extract-plugin
export default {"Root":"game-config_Root__60E3w","GameData":"game-config_GameData__eWQ6C","Data":"game-config_Data__6al2v"};